import { Box, Typography } from "@mui/material";
import { Inbox } from "@mui/icons-material";

interface EmptyStateProps {
  message: string;
}

export default function EmptyState({ message }: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        gap: 2,
        p: 3,
      }}
    >
      <Inbox sx={{ fontSize: 48, color: "text.secondary" }} />
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {message}
      </Typography>
    </Box>
  );
}
